/// <reference types="google.maps" />

import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

import {
  MapInfoWindow,
  MapMarker
} from '@angular/google-maps';

@Component({
  selector: 'app-google-location',
  standalone: false,
  templateUrl: './google-location.component.html'
})
export class GoogleLocationComponent implements AfterViewInit {

  @ViewChild('searchInput')
  searchInput!: ElementRef<HTMLInputElement>;

  @ViewChild(MapInfoWindow)
  infoWindow!: MapInfoWindow;

  @ViewChild(MapMarker)
  marker!: MapMarker;

  @Output()
  locationChanged = new EventEmitter<any>();

  zoom = 15;

  center: google.maps.LatLngLiteral = {
    lat: 30.0444,
    lng: 31.2357
  };

  markerPosition: google.maps.LatLngLiteral = {
    lat: 30.0444,
    lng: 31.2357
  };

  markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };

  selectedAddress = '';

  @Input() latitude?: string;
  @Input() longitude?: string;

  ngAfterViewInit(): void {

    this.initAutocomplete();

    if (
      this.latitude != null &&
      this.longitude != null
    ) {

      this.reverseGeocode(
        Number(this.latitude),
        Number(this.longitude)
      );

    } else {

      this.getCurrentLocation();

    }
  }

  private initAutocomplete(): void {

    const autocomplete =
      new google.maps.places.Autocomplete(
        this.searchInput.nativeElement,
        {
          fields: [
            'formatted_address',
            'geometry'
          ]
        }
      );

    autocomplete.addListener('place_changed', () => {

      const place = autocomplete.getPlace();

      if (!place.geometry?.location) {
        return;
      }

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.updateLocation(
        lat,
        lng,
        place.formatted_address || ''
      );
    });
  }

  getCurrentLocation(): void {

    navigator.geolocation.getCurrentPosition(
      position => {

        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        this.reverseGeocode(lat, lng);
      }
    );
  }

  mapClicked(event: google.maps.MapMouseEvent): void {

    if (!event.latLng) {
      return;
    }

    this.reverseGeocode(
      event.latLng.lat(),
      event.latLng.lng()
    );
  }

  markerDragged(event: google.maps.MapMouseEvent): void {

    if (!event.latLng) {
      return;
    }

    this.reverseGeocode(
      event.latLng.lat(),
      event.latLng.lng()
    );
  }

  reverseGeocode(
    lat: number,
    lng: number
  ): void {

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        location: { lat, lng }
      },
      (results, status) => {

        if (
          status === 'OK' &&
          results?.length
        ) {

          this.updateLocation(
            lat,
            lng,
            results[0].formatted_address
          );
        }
      }
    );
  }

  private updateLocation(
    lat: number,
    lng: number,
    address: string
  ): void {

    this.center = { lat, lng };

    this.markerPosition = { lat, lng };

    this.selectedAddress = address;

    this.searchInput.nativeElement.value = address;

    this.emitLocation();

    setTimeout(() => {
      this.infoWindow.open(this.marker);
    });
  }

  private emitLocation(): void {

    this.locationChanged.emit({
      address: this.selectedAddress,
      latitude: this.markerPosition.lat,
      longitude: this.markerPosition.lng
    });
  }
}
